/**
 * Shown in place of the whole app when the clinic's staff IP allowlist refuses
 * a request (403 `ip-not-allowed` from ruby-hq's `ipGate`, migration 0173):
 * the person is signed in, but not on their clinic's network. Try again
 * reloads (they may have reconnected); Sign out ends the session.
 *
 * Plan: docs/plans/2026-10-07-well-staff-ip-allowlist.md
 */

import { ShieldAlert } from 'lucide-react';

export function NetworkRefusedPage({ ip, onSignOut }: { ip: string | null; onSignOut: () => Promise<void> }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div
        data-testid="network-refused"
        className="max-w-md w-full bg-white rounded-xl border border-gray-200 shadow-sm p-6 text-center"
      >
        <ShieldAlert size={32} className="mx-auto text-amber-600" />
        <h1 className="mt-3 text-lg font-semibold text-gray-900">Only from your clinic&apos;s network</h1>
        <p className="mt-2 text-sm text-gray-600">
          Your clinic allows Ruby to be used only from its own network. Connect from the clinic, or
          ask your IT team to add this address.
        </p>
        <p className="mt-3 text-sm text-gray-900">
          Your address: <span className="font-mono">{ip ?? 'unknown'}</span>
        </p>
        <div className="mt-5 flex justify-center gap-3">
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="px-4 py-2 text-sm font-medium rounded-lg bg-gray-900 text-white"
          >
            Try again
          </button>
          <button
            type="button"
            onClick={() => void onSignOut()}
            className="px-4 py-2 text-sm font-medium rounded-lg border border-gray-300 text-gray-700"
          >
            Sign out
          </button>
        </div>
      </div>
    </div>
  );
}
